import React, { useMemo } from 'react';
import { isEqual } from 'lodash';
import { PauseAutocomplete2 } from '../PauseAutocomplete2';
import { PauseFormField2 } from './index';

interface Props {
  showErrorMessage?: boolean, name: string, disabled?: boolean,
  fieldProps?: {[x:string]: any},
  showErrorOnlyOnTouched?: boolean,
}

export const PauseFormAutocomplete = React.memo(({
  showErrorMessage, name, disabled,
  fieldProps, showErrorOnlyOnTouched = false,
}: Props) => {
  const memoizedFieldProps = useMemo(() => fieldProps, [fieldProps]);

  return (
    <PauseFormField2
      name={name}
      disabled={disabled}
      fieldProps={memoizedFieldProps}
      showErrorMessage={showErrorMessage}
      showErrorOnlyOnTouched={showErrorOnlyOnTouched}
      render={({ field, state, helpers: { setValue } }) => (
        <PauseAutocomplete2
          {...state}
          {...field}
          value={field.value}
          onChange={(newValue) => {
            setValue(newValue);
          }}
          TextfieldProps={{ ...state }}
          {...memoizedFieldProps}
        />
      )}
    />
  );
}, (
  newProps,
  oldProps,
) => isEqual(newProps, oldProps) && isEqual(newProps.fieldProps, oldProps.fieldProps));
